import React from "react";
import { Link } from "react-router-dom";
import "./precisionClicker.css";
import HeaderLink from "../common/headerLink";
import RainbowButton from "../common/rainbowButton";
import { screens } from "../utils/links";

export default function PrecisionClickerMenu() {
  return (
    <div>
      <HeaderLink />
      <section className="start-screen">
        <Link className="cta" to={screens.precisionClicker.play}>
          <RainbowButton>Play</RainbowButton>
        </Link>
        <Link className="cta" to={screens.precisionClicker.highScore}>
          <RainbowButton>High Score</RainbowButton>
        </Link>
        <Link className="cta" to={screens.precisionClicker.howTo}>
          <RainbowButton>How To Play</RainbowButton>
        </Link>
      </section>
    </div>
  );
}
